exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".couleur-orange[data-v-257e7dd4]{color:#ff9800;font-size:1.2em}.white-couleur[data-v-257e7dd4]{color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-257e7dd4","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/pages/settings/thematic-type.vue
// module id = 40DC
// module chunks = 1